// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type RefreshIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from refresh.svg
 */
export default function RefreshIcon(props: RefreshIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="RefreshIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M8 0a1 1 0 0 1 .993.883L9 1v7.585l1.293-1.292a1 1 0 0 1 1.32-.083l.094.083a1 1 0 0 1 .083 1.32l-.083.094-3 3a1 1 0 0 1-1.32.083l-.094-.083-3-3a1 1 0 0 1 1.32-1.497l.094.083L7 8.585V1a1 1 0 0 1 1-1"
        />
        <path
          fill="currentColor"
          d="M4.82 1.683a1 1 0 0 1-.248 1.392 6 6 0 1 0 6.856 0 1 1 0 0 1 1.144-1.64 8 8 0 1 1-9.144 0 1 1 0 0 1 1.392.248"
          clip-rule="evenodd"
        />
      </g>
    </svg>
  );
}
